<template>
    <div class="users">
        <div class="user-list">

            <div class="pagination">
                <div class="page-subtitle">{{ total_item }} users</div>
                <el-pagination @current-change="page => paginate(page, 'top')" :current-page.sync="params.page" :page-size="params.limit" :pager-count="11" layout="sizes, prev, pager, next" :page-sizes="page_sizes" @size-change="handleSizeChange" :total="total_item"></el-pagination>
                <button @click="openEdit()" class="btn btn-outline-secondary btn-sm">Créer</button>
            </div>
            <el-table style="width: 100%" ref="multipleTable" :data="users" @selection-change="handleSelectionChange" stripe @sort-change="changeSort" v-loading="loading">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="name" label="Nom" sortable="custom"></el-table-column>
                <el-table-column prop="email" label="Email" sortable="custom"></el-table-column>
                <el-table-column prop="role" label="Role" sortable="custom" width="90"></el-table-column>
                <el-table-column label="Actions" fixed="right">
                    <template slot-scope="scope">
                        <a href="#" @click.prevent="openEdit(scope.row)" >
                            <i class="fe fe-edit"></i>
                        </a>
                        <a href="#" class="text-danger" @click.prevent="removeUser(scope.row)" >
                            <i class="fe fe-trash"></i>
                        </a>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination :page-size="params.limit" layout="sizes, prev, pager, next" :pager-count="11" :total="total_item" @current-change="page => paginate(page, 'bottom')" :page-sizes="page_sizes" @size-change="handleSizeChange" :current-page="params.page">
                </el-pagination>
            </div>
        </div>
        <el-dialog @closed="closeEdit" title="Création / Modification" v-loading="modal.createEditUser.loader" :visible.sync="modal.createEditUser.display" :close-on-click-modal="false" :close-on-press-escape="true" width="80%">
            <el-form class="formCreateEditUser" ref="formCreateEditUser" :rules="rules" :model="modal.createEditUser.form" label-position="top">                
                <el-form-item prop="name" label="Nom">
                    <el-input v-model="modal.createEditUser.form.name"></el-input>
                </el-form-item>
                <el-form-item prop="email" label="Email">
                    <el-input v-model="modal.createEditUser.form.email"></el-input>
                </el-form-item>
                <el-form-item prop="password" label="Mot de passe">
                    <el-input type="password" v-model="modal.createEditUser.form.password"></el-input>
                </el-form-item>
                <el-form-item prop="role" label="Roles">
                    <el-select @change="setDefaultPermissions" filterable v-model="modal.createEditUser.form.role" placeholder="Role">
                        <el-option v-for="item in rolesOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <template v-if="hasPermissions()">
                     <el-transfer :titles="['Liste des droits', 'Droits accorder']" v-model="modal.createEditUser.form.permissions" :data="permissions"></el-transfer>
                </template>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="modal.createEditUser.display = false">Annuler</el-button>
                <el-button type="primary" @click="updateUser">Enregistrer</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import queryString from 'query-string';
import { EventBus } from '../../event-bus';
import User from '../../models/User';

export default {
    data() {
        return {
            rolesOptions: [
                { value: 'admin', label: 'Admin' },
                { value: 'freelance', label: 'Freelance', defaultPermission: [] },
                { value: 'direction', label: 'Direction', defaultPermission: [] },
            ],
            permissions: [],
            page_sizes: [10, 20, 30, 40, 50, 100, 200],
            params: {
                page: 1,
                orderBy: 'id',
                order: 'ASC',
                limit: 10
            },
            defaultParams: {
                page: 1,
                orderBy: 'id',
                order: 'ASC',
                limit: 10
            },
            filters: {},
            loading: false,            
            rules: {
                name: [
                    {
                        required: true,
                        message: 'Veuillez renseignez un nom',
                        trigger: 'blur'
                    }
                ],
                email: [
                    {
                        required: true,
                        message: 'Veuillez renseigner un email',
                        trigger: 'blur'
                    },
                ],
                role: [
                    {
                        required: true,
                        message: 'Veuillez renseigner un role',
                        trigger: 'blur'
                    },
                ],
            },
            modal: {
                createEditUser: {
                    display: false,
                    loader: false,
                    form: {
                    }
                }
            }
        };
    },
    computed: {
        total_item() {
            return this.$store.getters['users/totalItems'];
        },
        users() {
            return this.$store.getters['users/items'];
        },
        currentUrl() {
            return (
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname
            );
        },
    },
    watch: {
        params: {
            handler(newV, oldV) {
                var newUrl =
                    this.currentUrl + '?' + queryString.stringify(newV);
                window.history.pushState({ path: newUrl }, '', newUrl);
            },
            deep: true
        }
    },
    mounted() {
        axios.get('/users/permissions').then((r)=>{
            this.permissions = r.data.data.permissions;
            this.rolesOptions.forEach((v)=>{
                if( r.data.data.defaultPermission[v.value] ) {
                    v.defaultPermission = r.data.data.defaultPermission[v.value];
                }
            })
        })
        this.$store.dispatch('app/setSearchMode', 'users');
        if (window.location.search) {
            var params = queryString.parse(window.location.search);
            for (let key in params) {
                switch (key) {
                    case 'page':
                    case 'limit':
                        params[key] = parseInt(params[key]);
                        break;
                    case 'brand_id':
                    case 'manufacturer_id':
                        this.$refs.filtersComponent.setFilter(
                            key,
                            parseInt(params[key]),
                            true
                        );
                        break;
                    case 'category_id':
                        if (typeof params[key] == 'Array') {
                            var value = params[key].map(v => parseInt(v));
                        } else {
                            var value = [parseInt(params[key])];
                        }

                        this.$refs.filtersComponent.setFilter(key, value, true);
                        break;
                    case 'q':
                        this.$store.dispatch('app/setQ', params[key]);
                        break;
                    case 'product_search':
                        this.$refs.filtersComponent.setFilter(
                            key,
                            params[key],
                            true
                        );
                        break;
                    default:
                        break;
                }
            }
            this.params = params;
        }
        this.fetch();
    },

    methods: {
        setDefaultPermissions()
        {
            if( !this.modal.createEditUser.form.permissions.length && this.currentRole().defaultPermission ) {
                this.modal.createEditUser.form.permissions = this.modal.createEditUser.form.permissions.concat(this.currentRole().defaultPermission);
            }
        },
        currentRole()
        {
            return this.rolesOptions.find((v)=>v.value == this.modal.createEditUser.form.role);
        },
        hasPermissions()
        {
            var role = this.rolesOptions.find((v)=>v.value == this.modal.createEditUser.form.role);
            return role && role.defaultPermission && role.defaultPermission.length
        },
        removeUser(user)
        {
            this.$confirm('Ceci effacera l\'utilisateur ?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Annuler',
                type: 'warning'
            }).then(() => {
                axios.delete('/users/'+user.id).then(()=>{
                    this.fetch()
                    this.$message({
                        type: 'success',
                        message: 'Utilisateur supprimé'
                    });
                }).catch(()=>{

                })

            }).catch(() => {

            });
        },
        updateUser()
        {
            if( !this.modal.createEditUser.form.id  ) {
                this.rules['password']= [{ required: true, message: 'Le champ mot de passe est obligatoire', trigger: 'blur' }];
            } else {
                this.rules['password']= [];
            }
            this.$refs.formCreateEditUser.validate((valid, errors) => {
                if (valid) {
                    if( this.modal.createEditUser.form.id ) {
                        axios
                        .put('/users/' + this.modal.createEditUser.form.id, this.modal.createEditUser.form)
                        .then(r => {
                            this.closeEdit()
                            this.$message({
                                message: 'Utilisateur mise à jour.',
                                type: 'success'
                            });
                            this.fetch()
                        })
                        .catch(e => {
                            if (e.response && e.response.status == 422) {
                                this.$message.error(e.response.data.errors);
                            } else {
                                this.$message.error(
                                    'Erreur lors de la mise à jour.'
                                );
                            }
                        })
                        .then(() => {});
                    } else {
                        axios
                        .post('/users', this.modal.createEditUser.form)
                        .then(r => {
                            this.closeEdit()
                            this.$message({
                                message: 'Utilisateur créer.',
                                type: 'success'
                            });
                            this.fetch()
                        })
                        .catch(e => {
                            if (e.response && e.response.status == 422) {
                                this.$message.error(e.response.data.errors);
                            } else {
                                this.$message.error(
                                    'Erreur lors de la mise à jour.'
                                );
                            }
                        })
                        .then(() => {});
                    }

                }
            })
        },
        openEdit( user )
        {
            if( !user ) {
                user = new User
            }
            this.modal.createEditUser.form = user.toDatas();
            this.modal.createEditUser.display = true;
        },
        closeEdit()
        {
            this.modal.createEditUser.form = {  };
            this.modal.createEditUser.display = false;
        },
        handleSelectionChange(val) {
            this.$store.dispatch('users/setApplyToAllResults', false);
            this.multipleSelection = val;
        },

        fetch(params) {
            if (!params) {
                params = {};
            }
            params = { ...params, ...this.params };
            this.loading = true;
            return this.$store.dispatch('users/fetch', params).then(() => {
                this.loading = false;
            });
        },

        updateUserInList(id, data) {
            this.$store.dispatch('users/updateInList', { id, data });
        },

        deleteUserInList(id) {
            this.$store.dispatch('users/removeInList', id);
        },

        goToPage(p) {
            this.params.page = p;
            this.fetch();
        },

        changeSort(s) {
            this.params.orderBy = s.prop;
            this.params.order = s.order == 'ascending' ? 'asc' : 'desc';

            this.fetch();
        },

        removeAllFiltersToParams(params) {
            var newParams = {};
            for (let k in this.defaultParams) {
                newParams[k] = params[k];
            }
            return newParams;
        },

        onUpdateFilters(filters) {
            this.params.page = 1;
            this.params = this.removeAllFiltersToParams(this.params);
            this.params = { ...this.params, ...filters };
            if (!Object.values(filters).length) {
                this.params = Object.assign({}, this.defaultParams);
                setTimeout(() => {
                    window.history.pushState(
                        { path: this.currentUrl },
                        '',
                        this.currentUrl
                    );
                }, 100);
            }
            this.fetch();
        },

        handleSizeChange(val) {
            this.params.limit = val;
            this.fetch();
        },

        openModalEdit(user) {
            this.modal.display = true;
            this.modal.user = user.clone();
        },

        closeModalEdit() {
            this.modal.display = false;
        },

        onUpdateUser(user) {
            this.updateUserInList(user.id, user);
            this.$refs.filtersComponent.validFilters();
            this.closeModalEdit();
        },

        updateUsers(users) {
            this.$refs.multipleTable.clearSelection();
            users.forEach(user => {
                this.updateUserInList(user.id, user);
            });
        },

        paginate(page, paginator) {
            this.params.page = page;
            this.loader = true;
            this.fetch()
                .then(r => {
                    if (paginator == 'bottom') {
                        var element = document.querySelector(
                            '.users .user-list'
                        );
                        element.scrollIntoView();
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        },

        onDeleteUser(id) {
            this.deleteUserInList(id);
            this.closeModalEdit();
        },

        filterInTab(name, value) {
            this.$refs.filtersComponent.setFilter(name, value);
        }
    }
};
</script>
<style lang="scss">
.users {
    .pagination {
        margin: 25px 0;
        .el-pagination {
            margin: 0 auto;
        }
    }
    .el-transfer-panel {
        width: 410px;
    }
}

</style>
